import React from 'react'
import { Unsubscribe } from '../../src/components'

export default function UnsubscribePage() {
  return (
    <div className="cure-inner-container">
      <Unsubscribe />
    </div>
  )
}
